module.exports = __webpack_public_path__ + "static/img/OIP-C.a20c5c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/OIP-C.jpg
// module id = 2CzL
// module chunks = 0